import Vue from 'vue'
import App from './App.vue'
import router from './router'
import mstore from './store'
import './registerServiceWorker'
import api from "./util/api"
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.config.productionTip = false


let store: any = mstore


// if ( localStorage.getItem("vnet")) {
//   store.replaceState(
//       Object.assign(
//           {},
//           store.state,
//           JSON.parse(localStorage.getItem("vnet") as string)
//       )
//   );
//   localStorage.removeItem("vnet")
// }

// window.addEventListener("unload", () => {
//   localStorage.setItem("vnet", JSON.stringify(store.state));  
// });


// router.beforeEach((to,from,next) => {

//   let storetoken = store.state.core.token

//   let token = (to.query.token === '' || to.query.token == undefined) ? storetoken : to.query.token
//   if(token === '' || token == undefined){ // 首页进入无token
//     window.location.href = api.authorize + '?url='+ encodeURIComponent(window.location.href)
//   }else{ 
//     if(token != storetoken){
//         store.commit('core/settoken',{
//           data:token
//         })
        
//     }

//   }
//   store.commit('core/setCardInfo')
//   next()

// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
